<template>
  <section v-if="view.visible || view.error" class="deposit-receipt activity-record-panel" aria-label="原首存申请" :aria-busy="view.busy">
    <h3>原首存申请</h3>
    <span v-if="view.requestId" class="receipt-number">申请编号：{{ view.requestId }}</span>
    <span v-if="view.busy" role="status">正在核对原申请…</span>
    <ErrorNotice v-if="view.error" :message="view.error"></ErrorNotice>
    <template v-if="view.receipt">
      <span>{{ statusText }}</span>
      <dl class="receipt-facts">
        <div><dt>活动场馆：</dt><dd>{{ view.receipt.venueName }}</dd></div>
        <div><dt>申请本金：</dt><dd>{{ view.receipt.amount }} CNY</dd></div>
        <div><dt>实际彩金：</dt><dd>{{ view.receipt.bonusAmount }} CNY</dd></div>
        <div><dt>流水要求：</dt><dd>{{ view.receipt.requiredTurnover }} CNY</dd></div>
        <div><dt>平台转账编号：</dt><dd>{{ view.receipt.transferNo }}</dd></div>
        <div><dt>申请时间：</dt><dd>{{ formatPrizeTime(view.receipt.createdAt) }}</dd></div>
        <div v-if="view.receipt.completedAt"><dt>完成时间：</dt><dd>{{ formatPrizeTime(view.receipt.completedAt) }}</dd></div>
      </dl>
    </template>
    <ActivityAction variant="text" :disabled="view.busy" @click="$emit('refresh')">重新核对原申请</ActivityAction>
  </section>
</template>
<script setup>
import ErrorNotice from '../feedback/ErrorNotice.vue'
import { computed } from 'vue';
import ActivityAction from './ActivityAction.vue';
import { displayRecordTime as formatPrizeTime } from '../../utils/recordQueries.js';
const props=defineProps({view:{type:Object,required:true}});
defineEmits(['refresh']);
const statusText=computed(()=>({SUCCESS:'本金和彩金已转入所选场馆',FAILED:'场馆划转明确失败，本金和彩金已退回中心钱包',PROCESSING:'申请已留痕，正在核对场馆结果，请勿重复申请',MANUAL:'原转账正在人工核对，请保留申请编号'})[props.view.receipt?.transferStatus]||'');
</script>
<style scoped src="./activity-records.css"></style>
